var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticStyle:{"padding":"0 3px","min-width":"30px"},attrs:{"disabled":_vm.loading || _vm.disabled,"loading":_vm.loading,"color":_vm.colorDefault,"block":_vm.block,"dark":!_vm.loading,"depressed":"","rounded":""},on:{"click":function($event){return _vm.$emit("click")}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }